import useLocale from "hooks/useLocale";
import { DefaultMDXProvider } from "../components/default-mdx-provider";
import * as IndexAr from "../content/ar/index.mdx";
import * as IndexDe from "../content/de/index.mdx";
import * as IndexEn from "../content/en/index.mdx";
import * as IndexEs from "../content/es/index.mdx";
import * as IndexFr from "../content/fr/index.mdx";
import * as IndexRu from "../content/ru/index.mdx";
import * as IndexZh from "../content/zh/index.mdx";

const localeContents = {
  ar: IndexAr,
  de: IndexDe,
  en: IndexEn,
  es: IndexEs,
  fr: IndexFr,
  ru: IndexRu,
  zh: IndexZh,
} as const;

export default function Index() {
  const locale = useLocale();
  const { default: Content, frontmatter } = localeContents[locale];

  return (
    <DefaultMDXProvider frontmatter={frontmatter}>
      <Content />
    </DefaultMDXProvider>
  );
}
